import React, { Component } from 'react';
import { string, func } from 'prop-types';
import { connect } from "react-redux";
import { clearErrorsForInput } from '../../actions/error.js';
import './Input.css';

class Input extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: false,
      msgs: [''],
      errorStyle: ''
    };

    this.onChange = this.onChange.bind(this);
    this.renderErrors = this.renderErrors.bind(this);

  }

  static PropTypes = {
    type: string,
    name: string,
    placeholder: string,
    onChange: func,
    value: string,
    thumbnail: string
  }

  onChange = (e) => {
    if (this.props.onChange) {
      this.props.onChange(e.target.value, e.target.name);
      this.props.deleteErrors(e.target.name);
    }
  }

  // showError = () => {
  //   if(this.state.error) {
  //     return (
  //       <div>
  //           {this.state.message}
  //       </div>
  //     )
  //   }
  // }

  renderErrors = ()=> {
    if (!this.state.error) {
      return null;
    } else {
      return (
        <ul className='errors'>
          {this.state.msgs.map((msg, i) =>
            (<li className="error-msg" key={i}>{msg}</li>)
          )}
        </ul>
      );
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.errors) {
      //check if this.props.name is in Object.keys()
      if (Object.keys(nextProps.errors).includes(this.props.name)) {
        this.setState({ error: true, msgs: nextProps.errors[this.props.name] });
      } else {
        this.setState({ error: false, msgs: [] });
      }
    }
  }

  render() {
    const { children, thumbnail } = this.props;
    return (
      <div className='input-container'>
        <div className={`input ${children ? 'left-padding' : ''} ${thumbnail ? 'right-padding' : ''}`}>
          {this.props.children &&
            <div className="icon">
              {children}
            </div>
          }
          <input
            type={this.props.type}
            name={this.props.name ? this.props.name : this.props.type}
            placeholder={this.props.ph}
            onChange={this.onChange}
            value={this.props.value}
            className={this.props.errorStyle}
            className={this.state.error ? 'has-error' : ''}
            spellCheck="false"
            readOnly={this.props.readOnly}
            disabled={this.props.readOnly}
          />
          {/* {this.props.thumbnail &&
            <div className="thumbnail">
              <img src={thumbnail} alt="recently loged in thumbnail" />
            </div>
          } */}
        </div>
        {this.renderErrors()}
      </div>
    )
  }
}

const mapStateToProps = state => ({ errors: state.errors });

const mapDispatchToProps = {
  deleteErrors: inputName => dispatch => dispatch(clearErrorsForInput(inputName))
};

export default connect(mapStateToProps, mapDispatchToProps)(Input);
// export default Input;




// /*  My version  */

// import React from 'react';
// import './Input.css';
// // import FormFields from '../../../../../formfields.js';

// const formFields = (props) => {

//   const renderFields = () => {
//     const formArray = [];

//     for(let element in props.formdata) {
//       formArray.push({
//         id:element,
//         settings:props.formdata[element]
//       })
//     }
    
//     return formArray.map( (item, i) => (
//       <div key={i} className="form-row">
//         {renderTemplates(item)}
//       </div>
//     ) )
//   }

//   const changeHandler = (e, element, blur) => {
//     e.preventDefault();
//     let newState = props.formdata;
//     newState[element].value = e.target.value;

//     // Validation
//     if(blur) {
//       newState[element].blured = true;
//     }
//     let validData = validate(newState[element]);
//       newState[element].valid = validData[0];
//       newState[element].validationMessage = validData[1];
//       newState[element].errorClass = validData[2];
//       newState[element].touched = true;

//     props.change(newState)
//   }

//   const validate = element => {
//     let error = [true, '', ''];

//     // Email Validation
//     if(element.blured && element.validation.email) {
//       const re = RegExp(/^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/);
//       let valid = re.test(element.value);
//       let message = '';
//       if(!valid) {
//         message = (
//           <span>Insert Correct Email</span>
//         )
//       } else {
//         message = ''
//       }
//       error = !valid ? [valid, message, 'error'] : [true, '', ''];
//     }

//     if(element.validation.required) {
//       const valid = element.value.trim() !=='';
//       let message = ''
//       if(!valid) {
//         message = (
//           <span>This Field is Requierd</span>
//         )
//       } else {
//         message = ''
//       }
//       error = !valid ? [valid, message] : error;
//     }

//     return error;
//   }

//   const showValidation = data => {
//     let errorMessage = null;
//     let isRequired = data.validation.required;
//     let valid = data.valid;
//     if(isRequired && !valid) {
//       errorMessage = (
//         <div className="error-message">
//           {data.validationMessage}
//         </div>
//       )
//     }

//     return errorMessage;
//   }

//   // const renderIcons = (icon) => {
//   //   switch(icon) {
//   //     case('name'): return <MdPersonOutline size="18" /> 
//   //       break;

//   //     case('password'): return <MdLockOutline size="18" />
//   //       break;
      
//   //     default: return null;
//   //   }
//   // }

//   const renderTemplates = data => {
//       let template = null;
//       let values = data.settings;

//       switch(values.element) {
//         case('input'):
//           template = (
//             <div className="input-container">
//               <div className="input left-padding right-padding">
//                   <div className="icon">
//                     {/* {renderIcons(data.id)} */}
//                   </div>
//                   <input
//                     {...values.config}
//                     onBlur={(e)=>changeHandler(e, data.id, true)}
//                     onChange={(e)=>changeHandler(e, data.id, false)}
//                     // onChange={(e)=>changeEmail(e, data.id, false)}
//                     className={values.errorClass}
//                   >
//                   </input>
//                   { showValidation(values) }
//               </div>
//             </div>
//           )
//         break;

//         default:
//             template = null;
//       }

//       return template;
//   }

//   return (
//     <div>
//         {renderFields()}
//     </div>
//   )
// }

// export default formFields;


// WEBPACK FOOTER //
// ./src/common/input/Input.js